$( document ).ready(function() {
	$('.homeSlider').slick({
		dots: false,
		autoplay: true,
		speed: 6000,
		arrows: false,
	});
});

